import React, {memo} from "react";
import styles from "./styles.module.scss";
import {CourtModel} from "@/app/api/courts";
import {TextMedium14, ThirtyText} from "@/app/components/texts";
import LazyAssets from "@/app/utils/assets_widget";
import Space from "@/app/components/space";
import {SmartImage} from "@/app/components/smart_image/widget";

interface ChipProps {
  place?: CourtModel;
  onClick?: () => void
}

const PlaceWidget: React.FC<ChipProps> = ({place, onClick}) => (
  <div className={styles.place} onClick={onClick}>
    <div className={styles.image}>
      <SmartImage
        className={styles.image}
        alt={place?.name}
        sources={[
          place?.mainImageUrl ?? "",
          "https://app.padelmatchapp.com/static/media/auth_first.ba3208e7edc85629cc09.png",
          "https://www.ltapadel.org.uk/4961c8/globalassets/information-articles/indoor-padel-court.jpg?w=1200",
        ]}
      />
    </div>
    <div className={styles.info}>
      <ThirtyText text={place?.name} className={styles.title}/>
      <Space.H16/>
      <div className={styles.infoRow}>
        <div className={styles.iconText}>
          <LazyAssets.GolfHole/> <TextMedium14 text={(1).toString()}/>
        </div>
        <div className={styles.iconText}>
          <LazyAssets.Star className={styles.star}/> <TextMedium14 text={(5).toString()}/>
        </div>
      </div>
      <Space.H8/>
      <TextMedium14 text={place?.address} className={styles.subtitle}/>
    </div>
  </div>);

export default memo(PlaceWidget);